import type { Breadcrumb } from 'types/page-model';
import { createSelector } from 'reselect';
import { getBreadcrumbs } from 'features/page-model/selectors';
import { getDisplayedName } from 'features/product-info';

export const getBreadcrumbsWithCurrentPageLink = createSelector(
  getBreadcrumbs,
  getDisplayedName,
  (breadcrumbs, displayedName): Breadcrumb[] =>
    (breadcrumbs || []).concat({
      label: displayedName ?? '',
      link: '#',
    }),
);
